import { observer } from 'mobx-react-lite';
import styles from '@features/navigation/components/Navigation/Navigation.styles';
import stylesMobile from '@features/navigation/components/MegaMenuMobile/MegaMenuMobile.styles';
import { ICategory } from '@features/categories';
import Button from '@components/Button/Button';

type PropsType = {
  product: ICategory;
  color: string;
  isMobile: boolean;
  isActive?: boolean;
  onClick: (product: ICategory) => void;
  cy: string;
};
const ProductMenuItem = ({ product, color, isMobile = false, onClick, isActive = false, cy }: PropsType) => {
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onClick(product);
  };
  if (product?.behaviour === 'hidden') return null;
  return (
    <li sx={isMobile ? stylesMobile.productMenuItem : styles.productMenuItem(color)} role="menuitem" data-cy={cy}>
      <Button
        variant="link"
        onClick={handleClick}
        sx={styles.productActive(!!isActive)}
        addClassName="nav_menu-lvl-one"
      >
        {product.name}
      </Button>
    </li>
  );
};

export default observer(ProductMenuItem);
